<script lang="ts">
  import { onMount } from 'svelte';
  import { fade } from 'svelte/transition';
  import X from '../../assets/icons/x.svg.svelte';

  export let loadingState = {
    isLoading: false,
    completed: false,
    error: false,
    retry: false,
    functionAfterError: function () {
      this.isLoading = false;
    },
    functionAfterCompleted: function () {
      this.isLoading = false;
    },
  };

  let seconds = 40;
  let currentMessage = 0;
  let errorMessage = false;
  let messages = [
    '',
    'Dateien werden verarbeitet. Dieser Prozess kann bis zu 90 Sekunden dauern.',
    'Dateien werden verarbeitet. Dieser Prozess kann bis zu 90 Sekunden dauern.',
    'Texte werden ausgelesen.',
    'Die Resultate werden aufbereitet.',
    'Prozess wird abgeschlossen.',
  ];
  let loadingBar;

  const showMessages = () => {
    let interval = seconds / messages.length;

    for (let k = 0; k < messages.length - 2; k++) {
      setTimeout(
        () => {
          currentMessage = k + 1;
        },
        k * interval * 1000,
      );
    }
  };

  const closeModal = () => {
    loadingState = {
      ...loadingState,
      isLoading: false,
      error: false,
      retry: false,
    };
  };

  onMount(() => {
    loadingBar = document.querySelector('#loading-bar');
    loadingBar.style.transition = 'width ' + seconds + 's';
    loadingBar.style.width = '100%';
    showMessages();
  });

  $: if (loadingState.completed) {
    currentMessage = messages.length - 1;
    setTimeout(() => {
      loadingState.functionAfterCompleted();
    }, 300);
  }

  $: if (loadingState.retry) {
    loadingBar = document.querySelector('#loading-bar');
    loadingBar.style.transition = 'width ' + 0 + 's';
    loadingBar.style.width = '0px';
    setTimeout(() => {
      loadingBar.style.transition = 'width ' + seconds + 's';
      loadingBar.style.width = '100%';
    }, 1);
    showMessages();
  }

  $: if (loadingState.error) {
    errorMessage = 'Etwas ist schief gelaufen.';
    setTimeout(() => {
      loadingState.functionAfterError();
    }, 700);
  }
</script>

<div
  transition:fade
  class="fixed top-0 left-0 z-[3]
  flex h-screen w-full flex-col items-center justify-center bg-[#000a] backdrop-blur-[2px]"
>
  <div class="flex w-[90%] flex-col items-center">
    {#if errorMessage}
      <span
        class="z-[1] w-full text-center font-sans
        text-[20px] font-bold text-red-400"
      >
        {errorMessage}
      </span>
    {:else}
      {#if loadingState.retry}
        <span
          class="z-[1] w-[90%] text-center font-sans
      text-[16px] font-bold text-white">(Erneut versuchen)</span
        >
      {/if}
      <span
        class="z-[1] w-[90%] text-center font-sans
        text-[20px] font-bold text-white"
      >
        {messages[currentMessage]}
      </span>
    {/if}
    <div
      class="relative mt-8 flex h-8 w-full items-center
      justify-center overflow-hidden rounded-2xl border-[1px] border-[#fff] bg-white p-4 md:w-[60%]"
    >
      <div class="absolute h-8 w-full">
        {#if loadingState.completed || loadingState.error}
          <div
            id="completed-bar"
            class={`absolute left-0 top-0 
            h-8 w-full`}
            style={loadingState.error == true
              ? 'background-color: #F87171'
              : 'background-color: #34D399'}
          ></div>
        {/if}
        <div id="loading-bar" class="h-8 w-0 bg-[#176db7]"></div>
      </div>
    </div>
    <button
      on:click={closeModal}
      class="mt-8 flex h-14 w-14 items-center
        justify-center rounded-full border-[1px] border-white text-white duration-200 hover:bg-[#0003]"
    >
      <X />
    </button>
  </div>
</div>
